import React from 'react';

import './PlayerOptions.scss';
import {CompetitorType, useEventContext} from 'providers/EventProvider';
import {useSplitContext} from 'providers/SplitProvider';
import {setStoredCompetitorColor} from 'utils/competitorColors';

import {Box, Stack} from '@mui/material';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Checkbox from './Checkbox';

const PlayerOptions = (props: PlayerOptionsProps) => {
  const {player} = props;

  const {updatePlayers} = useEventContext();
  const {followedPlayerId, setFollowedPlayerId} = useSplitContext();
  const isFollowed = followedPlayerId === player.id;

  const onChangePlayerOptions = () => {
    updatePlayers((players) => players.map((p) => (p === player ? {...p, options: {...p.options, show: !p.options.show}} : p)));
  };

  const onChangePlayerColor = (color: string) => {
    setStoredCompetitorColor(player.deviceName, color);
    updatePlayers((players) =>
      players.map((p) =>
        p.deviceName === player.deviceName ? {...p, color, display: {...p.display, color}} : p
      )
    );
  };

  const onToggleFollow = () => {
    const nextId = isFollowed ? null : player.id;
    setFollowedPlayerId(nextId);
    updatePlayers((players) =>
      players.map((p) => ({
        ...p,
        options: {...p.options, highlight: nextId !== null && p.id === nextId}
      }))
    );
  };

  return (
    <Box
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.4)',
        padding: '2px',
        '@media (pointer: coarse)': {
          minHeight: 44,
          display: 'flex',
          alignItems: 'center'
        }
      }}
    >
      <Stack
        direction="row"
        sx={{
          marginBottom: 0,
          alignItems: 'center'
        }}
      >
        <Checkbox checked={player.options?.show} onClick={onChangePlayerOptions} color={player.color} />
        <Box sx={{display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0}}>
          <input
            type="color"
            className="player_color"
            value={player.color}
            title="Change color"
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => onChangePlayerColor(e.target.value)}
          />
          <Box>{player.name}</Box>
        </Box>
        <Box
          role="radio"
          aria-checked={isFollowed}
          aria-label={`Follow ${player.name}`}
          title={isFollowed ? 'Stop following' : 'Follow'}
          onClick={onToggleFollow}
          sx={{display: 'flex', cursor: 'pointer', ml: 0.5}}
        >
          {isFollowed ? (
            <RadioButtonCheckedIcon sx={{fontSize: 20, color: player.color}} />
          ) : (
            <RadioButtonUncheckedIcon sx={{fontSize: 20, color: 'rgba(0,0,0,0.35)'}} />
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default PlayerOptions;

type PlayerOptionsProps = {
  player: CompetitorType;
};
